// STYLES
import "../../styles/Components/faq/faqPublic.css";
import styles from "../../styles/Components/faq/AssistantSection.module.css";

// Images
import ai1 from "../../asset/Images/faq/AI Assistant/Assistant/1.png";
import ai2 from "../../asset/Images/faq/AI Assistant/Assistant/2.png";
import ai3 from "../../asset/Images/faq/AI Assistant/Assistant/3.png";
import ai4 from "../../asset/Images/faq/AI Assistant/Assistant/4.png";
import ai5 from "../../asset/Images/faq/AI Assistant/Assistant/5.png";
import ai6 from "../../asset/Images/faq/AI Assistant/Assistant/6.png";
import { useNavigate } from "react-router";
import { BiChevronLeft } from "react-icons/bi";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import {
  MdOutlinePsychology,
  MdInfoOutline,
  MdOutlineTimeline,
} from "react-icons/md";
import { HiOutlineSwitchHorizontal } from "react-icons/hi";

const AssistantSection = function () {
  const navigate = useNavigate();
  return (
    <div className={styles.helpWrapper}>
      <div className={styles.backBtn} onClick={() => navigate("/faq/all")}>
        <BiChevronLeft />
        <span>Back to Help Center</span>
      </div>

      <div className={styles.heroCard}>
        <div className={styles.heroIcon}>
          <MdOutlinePsychology />
        </div>
        <div className={styles.heroContent}>
          <h3 className={styles.heroTitle}>Assistant Section</h3>
          <p className={styles.heroDesc}>
            The AI Assistant page provides a centralized hub for AI-driven
            cryptocurrency trading insights. It displays an overall signal for
            each coin pair, updated from 1-hour and 15-minute timeframe
            analyses, to guide your trading decisions.
          </p>
        </div>
      </div>

      <div className={styles.stepContainer}>
        <div className={styles.stepHeader}>
          <div className={styles.stepNumWrap}>
            <span className={styles.stepNum}>1</span>
          </div>
          <div className={styles.stepInfo}>
            <h4 className={styles.stepTitle}>Overview of Signal Cards</h4>
          </div>
        </div>
        <div className={styles.subStepWrapper}>
          <div className={styles.subStepContainer}>
            <ul className={styles.helpList}>
              <li>
                Each card shows the coin pair, latest signal (e.g., Weak Sell),
                current price, stop loss, take profit, and position size.
                <br />
                Click "Run AI Backtest" to simulate past performance, or select
                a coin on the left to add it to your dashboard.
              </li>
            </ul>
            <div className={styles.imageWrap}>
              <LazyLoadImage
                src={ai1}
                alt="ai assistant"
                effect="blur"
                wrapperClassName="imageContainer"
              />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.stepContainer}>
        <div className={styles.stepHeader}>
          <div className={styles.stepNumWrap}>
            <span className={styles.stepNum}>2</span>
          </div>
          <div className={styles.stepInfo}>
            <h4 className={styles.stepTitle}>Understand the Signal Details</h4>
            <div className={styles.stepTag}>
              <MdInfoOutline />
              Tooltip Guide
            </div>
          </div>
        </div>
        <div className={styles.subStepWrapper}>
          <div className={styles.subStepContainer}>
            <p className={styles.helpLead}>
              The tooltip provides signal details:
            </p>
            <ul className={styles.helpList}>
              <li>
                <strong>1H Signal:</strong> Based on volume, indicates market
                trends in a 1-hour timeframe.
              </li>
              <li>
                <strong>15M Signal:</strong> Uses AI analysis to suggest
                buy/sell/hold in a 15-minute timeframe. Hover over the info icon
                on any coin card to view.
              </li>
            </ul>
            <div className={styles.imageWrap}>
              <LazyLoadImage
                src={ai2}
                alt="ai assistant"
                effect="blur"
                wrapperClassName="imageContainer"
              />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.stepContainer}>
        <div className={styles.stepHeader}>
          <div className={styles.stepNumWrap}>
            <span className={styles.stepNum}>3</span>
          </div>
          <div className={styles.stepInfo}>
            <h4 className={styles.stepTitle}>Place Your Trade</h4>
            <div className={`${styles.stepTag} ${styles.tagTrade}`}>
              <HiOutlineSwitchHorizontal />
              Trade Setup
            </div>
          </div>
        </div>
        <div className={styles.subStepWrapper}>
          <div className={styles.subStepContainer}>
            <p className={styles.helpLead}>
              Once you choose a certain signal, the following screen will
              appear. Use this section to set up your trade.
            </p>
            <ul className={styles.helpList}>
              <li>
                Choose an Exchange (e.g., Binance) and Asset (e.g., ADA/USDT).
              </li>
              <li>
                View the AI Trade Suggestion (e.g., Weak Sell) with stop loss,
                take profit, and position size.
              </li>
              <li>
                Select Buy or Sell to apply the AI suggestion, or use Manual
                Order for custom trades.
              </li>
            </ul>
            <div className={styles.imageWrap}>
              <LazyLoadImage
                src={ai3}
                alt="ai assistant"
                effect="blur"
                wrapperClassName="imageContainer"
              />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.stepContainer}>
        <div className={styles.stepHeader}>
          <div className={styles.stepNumWrap}>
            <span className={styles.stepNum}>4</span>
          </div>
          <div className={styles.stepInfo}>
            <h4 className={styles.stepTitle}>Run AI Backtest</h4>
            <div className={`${styles.stepTag} ${styles.tagBacktest}`}>
              <MdOutlineTimeline />
              Historical Performance
            </div>
          </div>
        </div>
        <div className={styles.subStepWrapper}>
          <div className={styles.subStepContainer}>
            <p className={styles.helpLead}>
              Click on the "Run AI Backtest" to evaluate the signal's
              performance using historical data. You will see three tabs, Live
              Analysis, Backtest Chart, and Backtest History.
            </p>
            <ul className={styles.helpList}>
              <li>
                The Live Analysis tab shows real-time AI signals for your
                selected exchange and pair.
                <br />
                It includes the current suggestion (e.g., Weak Sell), stop loss,
                take profit, position size, and last update time.
                <br />
                Use this to make informed trading decisions.
              </li>
              <div className={styles.imageWrap}>
                <LazyLoadImage
                  src={ai4}
                  alt="ai assistant"
                  effect="blur"
                  wrapperClassName="imageContainer"
                />
              </div>
              <li>
                The Backtest Chart tab displays a performance graph of AI-driven
                trades over the past 3-4 days for your selected pair.
                <br /> The equity value shows how your portfolio would have
                performed based on historical market data.
                <br /> Use this to evaluate the AI's effectiveness.
              </li>
              <div className={styles.imageWrap}>
                <LazyLoadImage
                  src={ai5}
                  alt="ai assistant"
                  effect="blur"
                  wrapperClassName="imageContainer"
                />
              </div>
              <li>
                The Backtest History tab lists past simulated trades for your
                selected pair.
                <br /> It shows signal time, entry/exit prices, times, and
                profit/loss percentage (P/L %).
                <br /> Use this to review the AI's historical performance and
                refine your strategy.
              </li>
              <div className={styles.imageWrap}>
                <LazyLoadImage
                  src={ai6}
                  alt="ai assistant"
                  effect="blur"
                  wrapperClassName="imageContainer"
                />
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssistantSection;
